import { LoadingModal } from "@portal/components/layout/LoadingModal";
import { useIsMutating } from "@tanstack/react-query";
import { ReactNode } from "react";

type GlobalLoadingProviderProps = {
	children: ReactNode;
};

export const GlobalLoadingProvider = ({ children }: GlobalLoadingProviderProps) => {
	const createBondRequestIsLoading = useIsMutating({
		mutationKey: ["createBondRequest"],
		exact: true,
	});
	const createSuretyAccountIsLoading = useIsMutating({
		mutationKey: ["createSuretyAccount"],
		exact: true,
	});

	return (
		<>
			{children}
			{(createBondRequestIsLoading > 0 || createSuretyAccountIsLoading > 0) && <LoadingModal />}
		</>
	);
};
